var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.884 30.7095C18.6015 32.07 16.0095 31.674 15.4875 29.5245C15.3916 29.1288 15.2037 28.7613 14.9389 28.452C14.6742 28.1427 14.3402 27.9002 13.964 27.7444C13.5879 27.5885 13.1803 27.5237 12.7743 27.5552C12.3684 27.5867 11.9756 27.7135 11.628 27.9255C9.3135 29.3355 6.663 26.6865 8.073 24.3705C8.28465 24.023 8.41133 23.6305 8.44273 23.2248C8.47413 22.8192 8.40936 22.4118 8.25371 22.0359C8.09805 21.66 7.85589 21.3261 7.54691 21.0614C7.23793 20.7967 6.87085 20.6086 6.4755 20.5125C3.8415 19.8735 3.8415 16.1265 6.4755 15.4875C6.8712 15.3916 7.23867 15.2037 7.548 14.9389C7.85733 14.6742 8.09978 14.3402 8.25562 13.964C8.41146 13.5879 8.47628 13.1803 8.4448 12.7743C8.41333 12.3684 8.28645 11.9756 8.0745 11.628C6.6645 9.3135 9.3135 6.663 11.6295 8.073C13.1295 8.985 15.0735 8.178 15.4875 6.4755C16.1265 3.8415 19.8735 3.8415 20.5125 6.4755C20.6084 6.8712 20.7963 7.23867 21.0611 7.548C21.3258 7.85733 21.6598 8.09978 22.036 8.25562C22.4121 8.41146 22.8197 8.47628 23.2257 8.4448C23.6316 8.41333 24.0244 8.28645 24.372 8.0745C26.6865 6.6645 29.337 9.3135 27.927 11.6295C27.7153 11.977 27.5887 12.3695 27.5573 12.7752C27.5259 13.1808 27.5906 13.5882 27.7463 13.9641C27.9019 14.34 28.1441 14.6739 28.4531 14.9386C28.7621 15.2033 29.1292 15.3914 29.5245 15.4875C31.1295 15.8775 31.7565 17.4225 31.4055 18.7125",
    stroke: "#2C3E50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24L25.5 28.5H31.5L28.5 33",
    stroke: "#2C3E50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C13.5 19.1935 13.9741 20.3381 14.818 21.182C15.6619 22.0259 16.8065 22.5 18 22.5C19.1935 22.5 20.3381 22.0259 21.182 21.182C22.0259 20.3381 22.5 19.1935 22.5 18C22.5 16.8065 22.0259 15.6619 21.182 14.818C20.3381 13.9741 19.1935 13.5 18 13.5C16.8065 13.5 15.6619 13.9741 14.818 14.818C13.9741 15.6619 13.5 16.8065 13.5 18Z",
    stroke: "#2C3E50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e24a1e1fbba33e565da0f92832453425.svg";
export { ForwardRef as ReactComponent };